import { TableConfigInterface } from "@kernel/listing/table/interfaces/table-config.interface";
import { IListStockTypeActionsParent } from "../interfaces/list-stock-type-component.interface";
import { StatusBadgeComponent } from "@shared-core/components/status-badge/status-badge.component";
import { formatDate } from "@angular/common";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";
import { IStockType } from "@app/shared/settings/stock-type/interfaces/stock-type.interface";
import { StockTypeRoutePaths } from "@app/applications/stock/domains/stock-type/stock-type-route-paths";

export const listStockTypeConfig = (parent: IListStockTypeActionsParent): TableConfigInterface =>
  <TableConfigInterface>{
    id: "settings/list-stockType",
    cols: [
      { id: "name", label: "STOCK_TYPE.COMMON.NAME", field: "name", sort: "name" },
      { id: "code", label: "STOCK_TYPE.COMMON.CODE", field: "code", sort: "code" },
      { id: "description", label: "STOCK_TYPE.COMMON.DESCRIPTION", field: "description", sort: "description" },
      {
        id: "status",
        label: "STOCK_TYPE.COMMON.STATUS",
        components: [
          {
            component: StatusBadgeComponent,
            inputs: (row: IStockType) => ({
              text: row.enabled ? "COMMON.ENABLED" : "COMMON.DISABLED",
              styleClass: row.enabled ? "status-active" : "status-inactive",
            }),
          },
        ],
      },
      {
        id: "createdAt",
        label: "COMMON.CREATED_AT",
        field: "createdAt",
        format: (row: IStockType) => (row.createdAt ? formatDate(row.createdAt, "dd/MM/YYY, HH:mm", parent.lang) : "-"),
      },
      {
        id: "updatedAt",
        label: "COMMON.UPDATED_AT",
        field: "updatedAt",
        format: (row: IStockType) => (row.updatedAt ? formatDate(row.updatedAt, "dd/MM/YYY, HH:mm", parent.lang) : "-"),
      },
      {
        label: "STOCK_TYPE.COMMON.ACTIONS",
        id: "actions",
        actions: [
          {
            id: "pi-user-edit",
            tooltip: "STOCK_TYPE.ACTIONS.EDIT",
            icon: "pencil",
            tooltipMode: true,
            route: row => ({ route: [StockTypeRoutePaths.edit(row.id)] }),
            permissions: [PERMISSION_CONSTANTS.STOCK_TYPE.UPDATE],
          },
          {
            actions: [
              {
                id: "pi-user-disable",
                tooltip: "STOCK_TYPE.ACTIONS.DISABLE",
                tooltipMode: false,
                perform: row => parent.stockTypeListService.switchRowStatus(row).pipe(parent.takeUntilDestroy()).subscribe(),
                visible: (row: IStockType) => !!row?.enabled,
                permissions: [PERMISSION_CONSTANTS.STOCK_TYPE.DISABLE],
              },
              {
                id: "pi-user-enable",
                tooltip: "STOCK_TYPE.ACTIONS.ENABLE",
                tooltipMode: false,
                perform: row => parent.stockTypeListService.switchRowStatus(row).pipe(parent.takeUntilDestroy()).subscribe(),
                visible: (row: IStockType) => !row?.enabled,
                permissions: [PERMISSION_CONSTANTS.STOCK_TYPE.ENABLE],
              },
            ],
          },
        ],
      },
    ],
    select: ["id"],
    query: "stockTypes",
    queryFields: ["id", "enabled"],
    onCellClick: async (row: IStockType) => {
      await parent.router.navigate([StockTypeRoutePaths.view(row.id)]);
    },
    klass: row => (!row.enabled ? ["disabled"] : []),
  };
